import {api, authApi} from "../../src/api";
import {Notifications} from "../../src/notifications";
import {FreezeUI} from "../../src/freeze-ui";
import {Sortable} from '@shopify/draggable';
import {trackException} from "../../src/errors";

document.addEventListener("DOMContentLoaded", () => {

    initCancelAutoRenew();

    if (typeof Sortable === "undefined")
        return;

    const sortable = new Sortable(document.querySelector("#packages"), {
        draggable: "[data-package-id]",
        handle: "[data-package-id] .handle",
        mirror: {
            appendTo: "body",
            constrainDimensions: true
        }
    });

    sortable.on("sortable:stop", async (e) => {

        try {
            FreezeUI.Freeze();
            await api.post("?Handler=SetOrder", {
                id: e.data.dragEvent.data.originalSource.dataset.packageId,
                newIndex: e.data.newIndex,
                oldIndex: e.data.oldIndex
            });

            Notifications.showSuccess({ message: "Saved!" });
        } catch (err) {
            console.error(err);
            Notifications.showError({ message: "There was a problem saving the new order. Please try again later." })
        } finally {
            FreezeUI.UnFreeze();
        }
    });
});

const initCancelAutoRenew = () => {
    document.querySelector("[data-cancel-renewal]")?.addEventListener("click", e => {
        e.preventDefault();

        Notifications.confirm.fire({
            text: `Are you sure you want to cancel your renewal? This cannot be undone and you will need to rejoin manually.`
        })
            .then(async result => {
                if (result.isConfirmed) {
                    FreezeUI.Freeze();

                    try {
                        await authApi.post("?Handler=CancelRenewal")
                            .then(result => {
                                Notifications.setNotificationCookie("The renewal has been cancelled.")
                                location.reload();
                            })
                            .catch(err => {
                                trackException(err);
                                Notifications.showError({ message: "There was a problem cancelling the renewal." })
                            });

                    } catch (err) {

                    }
                }
            });
    })
}
